'use client'

import { currencyOptions, languageOptions } from '@/data/footer'

import { socialLinks } from '@/data/socials'

import React, { useEffect, useState } from 'react'

import CartLength from './components/CartLength'

import { openCart } from '@/utils/openCart'

import MobileNav from './components/MobileNav'

import Image from 'next/image'

import styles from './MobileHeader.module.css'

import { Select } from 'antd'

import 'antd/dist/reset.css'

import HeaderSearchBox from './components/HeaderSearchBox'

export default function MobileHeader({
  headerStyle,

  brand,

  cusomNav,

  categoryItems,

  storeInfo,
}) {
  const [scrollDirection, setScrollDirection] = useState('down')

  const { Option } = Select

  const bgColor = headerStyle?.HeaderBGColor ?? '#fff'

  const fonColor = headerStyle?.HeaderFontColor ?? '#000'

  const cartBG = headerStyle?.HeaderCartBGColor ?? '#b9a16b'

  const cartFont = headerStyle?.HeaderCartFontColor ?? '#ffffff'

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY

      if (currentScrollY > 250) {
        if (currentScrollY > lastScrollY.current) {
          // Scrolling down

          setScrollDirection('down')
        } else {
          // Scrolling up

          setScrollDirection('up')
        }
      } else {
        // Below 250px

        setScrollDirection('down')
      }

      lastScrollY.current = currentScrollY
    }

    const lastScrollY = { current: window.scrollY }

    // Add scroll event listener

    window.addEventListener('scroll', handleScroll)

    // Cleanup: remove event listener when component unmounts

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <header
      className={`header-mobile header_sticky ${
        headerStyle?.HeaderOnTopStyle === 1
          ? 'header_sticky-active'
          : scrollDirection === 'up'
            ? 'header_sticky-active'
            : 'position-absolute'
      }`}
      style={{
        color: fonColor,

        backgroundColor: bgColor,
      }}
    >
      {/* Header */}

      <div className="container d-flex align-items-center h-100">
        <a className="mobile-nav-activator d-block position-relative" href="#">
          <svg
            className="nav-icon"
            width="25"
            height="18"
            viewBox="0 0 25 18"
            xmlns="http://www.w3.org/2000/svg"
          >
            <use href="#icon_nav" />
          </svg>

          <span className="btn-close-lg position-absolute top-0 start-0 w-100"></span>
        </a>

        <div className="logo">
          <a href="/">
            <Image
              src={headerStyle?.LogoPath}
              width={112}
              height={28}
              alt="Logo"
              className="logo__image d-block"
              style={{
                width: '100px', // 寬度自動

                height: 'auto', // 高度自動

                maxWidth: '100%', // 不超出容器

                objectFit: 'contain', // 保持比例不裁切
              }}
            />
          </a>
        </div>

        {storeInfo?.CartButtonEnable && (
          <a
            onClick={() => openCart()}
            className="header-tools__item header-tools__cart js-open-aside"
          >
            <svg
              className="d-block"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <use href="#icon_cart" />
            </svg>

            <span
              className="cart-amount d-block position-absolute js-cart-items-count"
              style={{
                background: cartBG,

                color: cartFont,
              }}
            >
              <CartLength />
            </span>
          </a>
        )}
      </div>

      {/* Nav */}

      <nav className="header-mobile__navigation navigation d-flex flex-column w-100 position-absolute top-100 bg-body overflow-auto">
        <div className="container mt-4 mb-3">
          <HeaderSearchBox
            headerStyle={headerStyle}
            variant="mobile"
            placeholder="搜尋商品"
          />
        </div>

        <div className="container flex-grow-1 overflow-scroll">
          <ul className="navigation__list list-unstyled position-relative">
            <MobileNav
              headerStyle={headerStyle}
              setScrollDirection={setScrollDirection}
              brand={brand}
              cusomNav={cusomNav}
              categoryItems={categoryItems}
            />
          </ul>
        </div>

        {/* Footer 放在 nav 裡的最後面 */}
        <footer
          className="mobile-footer border-top bg-white w-100 mt-auto"
          style={{
            // 自動獲取手機底部安全區域高度，並額外加上 16px 或 20px 讓畫面更寬鬆
            paddingBottom:
              'calc(var(--safe-area-inset-bottom, env(safe-area-inset-bottom)) + 20px)',
          }}
        >
          <div
            className="customer-links container mt-3 mb-2 pb-1"
            style={{ height: '115px' }} // 如果加了 padding 還是擠，可以考慮把這個寫死的 115px 刪除
          >
            <div className="d-flex align-items-center mb-1">
              <i className="bi bi-person" style={{ fontSize: '20px' }}></i>{' '}
              {/* 順手幫你把 class 改成 JSX 的 className */}
              <a
                href="/MemberCenter/account_dashboard"
                className="d-inline-block ms-2 text-uppercase align-middle fw-medium"
              >
                會員專區
              </a>
            </div>
            <div className="d-flex align-items-center">
              <i
                className="bi bi-box-arrow-left"
                style={{ fontSize: '20px' }}
              ></i>{' '}
              {/* class 改為 className */}
              <a
                href="/Logout"
                className="d-inline-block ms-2 text-uppercase align-middle fw-medium"
              >
                會員登出
              </a>
            </div>
          </div>
        </footer>
      </nav>

      {/* <!-- /.navigation --> */}
    </header>
  )
}
